import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-strength-icon',
  templateUrl: './strength-icon.component.html',
  styleUrls: ['./strength-icon.component.scss']
})
export class StrengthIconComponent implements OnInit {

  @Input() exerciseId: any;
  constructor() { }

  ngOnInit(): void {
  }

}
